module.exports = __webpack_public_path__ + "5689309f089316fecdb8b3e7984336a3.svg";